// extracted by mini-css-extract-plugin
module.exports = {"description":"Description-module--description--2IYuz"};